import React from "react";
import { useState, useEffect } from "react";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { useStores } from "../../store/index";
import { stopAdvancedProxyDetection } from '../../proxy-detection/proxyDetection';
export default function RecordingSection(isInterviewStarted, isInterviewCompleted, permission) {
  const { InterviewStore } = useStores();


  const [startTime, setStartTime] = useState(null);
  const [elapsedTime, setElapsedTime] = useState({ hours: 0, minutes: 0, seconds: 0 });
  const [recordedTime, setRecordedTime] = useState('');


  useEffect(() => {

    console.log(isInterviewStarted, isInterviewCompleted)

    if (isInterviewCompleted) {
      handleStop()
    }
    else if (isInterviewStarted) {
      handleStart();
    }
  }, [isInterviewStarted, isInterviewCompleted])


  useEffect(() => {
    let intervalId;

    if (startTime) {
      intervalId = setInterval(() => {
        const currentTime = Date.now();
        const elapsed = currentTime - startTime;

        const hours = Math.floor(elapsed / 3600000);
        const minutes = Math.floor((elapsed % 3600000) / 60000);
        const seconds = Math.floor((elapsed % 60000) / 1000);

        setElapsedTime({ hours, minutes, seconds });
      }, 1000);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [startTime]);

  const formatTime = () => {

    const { hours, minutes, seconds } = elapsedTime;
    return `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  };

  const handleStart = () => {
    setStartTime(Date.now());
  };

  const handleStop = () => {
    console.log("interview completed")
    const timeRecorded = formatTime();
    setStartTime(null);
    setElapsedTime({ hours: 0, minutes: 0, seconds: 0 });
    setRecordedTime(timeRecorded);
    InterviewStore.setRecordingTime(timeRecorded);
    stopAdvancedProxyDetection();
    console.log("🧾 Calling updateProxy with:", InterviewStore.interviewId, InterviewStore.interviewee);
    console.log("🧾 Current proxyDetectionResult:", window.proxyDetectionResult);

    const proxyData = window.proxyDetectionResult;
  if (proxyData) {
    InterviewStore.updateProxy(
      InterviewStore.interviewId,
      InterviewStore.interviewee
    )
      .then(() => console.log("✅ Proxy report submitted to interview_store ."))
      
      .catch(err => console.error("❌ Proxy report submission failed:", err));
  } else {
    console.warn("⚠️ No proxy data available to send.");
  }
  };




  return (
    <div className="flex flex-row items-center justify-end w-full">
      {/* <div className="flex flex-row items-center w-[45%] lg:w-[30%] md:w-[30%]">
        <BsFillRecordCircleFill className="text-xl text-red-400 p-0" />
        <p className="lg:text-xl text-sm gil-med ml-[1%] opacity-40">Recording { permission ? formatTime() : "00:00:00"}</p>
      </div> */}

      {isInterviewCompleted && (
        <div
          className="flex flex-row items-center bg-green-100 rounded-lg w-fit p-2  text-sm text-green-700"
          role="alert"
        >
          <AiOutlineCheckCircle size="1.2rem" />
          <div>
            <span className="gil-med px-2">
              Interview Completed
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
